/**
 * Teams — top-level menu grouping Org Teams + Opponents (AJ 2026-10-14, AD + Scheduler,
 * also HQ / League Admin). Same sub-tab look as the Registration hub. Each sub-tab is
 * the existing panel, unchanged. Doc: SCHEDULER_ROLE_PAGE §Top nav / AD_NAV.
 */
import React, { useEffect, useState } from 'react';
import { Shield, Swords } from 'lucide-react';
import { SubTabs } from './RegistrationHubPanel';
import OrgTeamsPanel from './org/OrgTeamsPanel';
import OpponentsPanel from './teams/OpponentsPanel';

const TABS = [
  { key: 'org-teams', label: 'Org Teams', icon: Shield, roles: ['company_support', 'league_admin', 'ad', 'scheduler'] },
  { key: 'opponents', label: 'Opponents', icon: Swords, roles: ['company_support', 'ad', 'scheduler'] },
];

export default function TeamsHubPanel({ orgId, isDark = true, userRole, initialTab, onInitialConsumed }) {
  const tabs = TABS.filter((t) => !userRole || t.roles.includes(userRole));
  const [active, setActive] = useState(initialTab || tabs[0]?.key || 'org-teams');
  useEffect(() => { if (initialTab) { setActive(initialTab); onInitialConsumed?.(); } }, [initialTab, onInitialConsumed]);
  const navBg = isDark ? 'bg-slate-800/60 border-slate-700' : 'bg-white border-slate-200';
  if (!orgId) return null;
  return (
    <div className="space-y-4" data-testid="teams-hub">
      {tabs.length > 1 && (
        <div className={`p-1.5 rounded-lg border ${navBg}`}>
          <SubTabs tabs={tabs} active={active} setActive={setActive} isDark={isDark} testidPrefix="teams-hub" />
        </div>
      )}
      {active === 'org-teams' && <OrgTeamsPanel orgId={orgId} isDark={isDark} />}
      {active === 'opponents' && <OpponentsPanel orgId={orgId} />}
    </div>
  );
}
